/**
 * The project directory's styles (#598). `dir-` is a naming convention, not a
 * scope: this is an ordinary global stylesheet, mounted by the tab and again by
 * each dialog, since a class only works while something that declares it is mounted.
 */
const css = `
  .dir-pad { padding: 10px var(--ew-s-4); margin: 0; }
  .dir-muted { color: var(--ew-n-500); }
  .dir-small { font-size: 12px; }
  .dir-error { color: var(--ew-danger-700); background: var(--ew-danger-50); border-radius: var(--ew-r-sm); padding: 8px 10px; }
  .dir-hd { display: flex; align-items: center; gap: 12px; padding-right: var(--ew-s-4); border-bottom: 1px solid var(--ew-n-200); flex-wrap: wrap; }
  .dir-hd .pw-card-hd { flex: none; }
  .dir-filter { flex: 1; min-width: 180px; max-width: 360px; padding: 6px 10px; border: 1px solid var(--ew-n-300); border-radius: var(--ew-r-sm); font: inherit; }
  .dir-group {
    font: var(--ew-fw-semibold) 11px/1 var(--ew-font); letter-spacing: var(--ew-ls-caption); text-transform: uppercase;
    color: var(--ew-green-700); padding: 14px var(--ew-s-4) 6px;
  }
  .dir-row {
    display: grid; grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 0.9fr) 110px;
    gap: 12px; align-items: center; padding: 9px var(--ew-s-4); border-bottom: 1px solid var(--ew-n-100); font-size: var(--ew-fs-body-sm);
  }
  .dir-row.team { grid-template-columns: 170px minmax(0, 1fr) minmax(0, 1fr) 140px; }
  .dir-row a { color: var(--ew-quality); overflow-wrap: anywhere; }
  .dir-role { color: var(--ew-n-700); }
  .dir-name { font-weight: var(--ew-fw-semibold); color: var(--ew-dark); }
  .dir-note { display: block; font-size: 12px; color: var(--ew-n-500); }
  .dir-co { overflow-wrap: anywhere; }
  .dir-co-meta { display: flex; flex-wrap: wrap; gap: 0 8px; margin-top: 2px; font-size: 12px; }
  .dir-divs { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 3px; }
  .dir-div {
    border-radius: var(--ew-r-sm); padding: 0 6px; font: var(--ew-fw-semibold) 10.5px/1.7 var(--ew-font);
    font-variant-numeric: tabular-nums; background: var(--ew-n-100); color: var(--ew-n-700);
  }
  .dir-phones { display: grid; gap: 2px; }
  .dir-acts { display: flex; gap: 4px; justify-content: flex-end; }
  .dir-act { border: 0; background: none; cursor: pointer; font: var(--ew-fw-medium) 12px/1 var(--ew-font); color: var(--ew-green-700); padding: 4px; }
  .dir-act:hover { text-decoration: underline; }
  /* Narrow screens: each contact stacks. */
  @media (max-width: 760px) {
    .dir-row, .dir-row.team { grid-template-columns: 1fr; gap: 2px; }
    .dir-acts { justify-content: flex-start; }
  }

  /* Dialogs */
  .dir-form { display: grid; gap: 12px; }
  .dir-grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .dir-grid3 { display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 10px; }
  @media (max-width: 560px) { .dir-grid2, .dir-grid3 { grid-template-columns: 1fr; } }
  .dir-field { display: grid; gap: 4px; font-size: 13px; }
  .dir-field > span { font-weight: var(--ew-fw-medium); color: var(--ew-n-700); }
  .dir-field input, .dir-field select, .dir-field textarea {
    font: inherit; padding: 7px 9px; border: 1px solid var(--ew-n-300); border-radius: var(--ew-r-sm); background: #fff;
  }
  .dir-field textarea { min-height: 56px; resize: vertical; }
  .dir-legend { font: var(--ew-fw-semibold) 12px/1 var(--ew-font); letter-spacing: var(--ew-ls-caption); text-transform: uppercase; color: var(--ew-n-500); margin: 4px 0 0; }
  .dir-pick { display: grid; gap: 4px; max-height: 260px; overflow-y: auto; }
  .dir-pick-row {
    display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 7px 10px;
    border: 1px solid var(--ew-n-200); border-radius: var(--ew-r-sm); background: #fff; text-align: left; cursor: pointer; font: inherit;
  }
  .dir-pick-row:hover { background: var(--ew-n-50); border-color: var(--ew-n-300); }
  .dir-pick-row:focus-visible { outline: 2px solid var(--ew-green); outline-offset: 1px; }
  .dir-row-actions { display: flex; gap: 8px; }
  .dir-chosen { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 8px 10px; background: var(--ew-green-50); border-radius: var(--ew-r-sm); }
  .dir-divpick { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 2px 12px; max-height: 220px; overflow-y: auto; border: 1px solid var(--ew-n-200); border-radius: var(--ew-r-sm); padding: 6px 10px; }
  .dir-divpick label { display: flex; align-items: center; gap: 6px; font-size: 12.5px; padding: 2px 0; }
  .dir-tabs { display: flex; gap: 6px; flex-wrap: wrap; }
  .dir-tab { border: 1px solid var(--ew-n-300); background: #fff; border-radius: var(--ew-r-pill); padding: 5px 12px; cursor: pointer; font: var(--ew-fw-medium) 12.5px/1 var(--ew-font); }
  .dir-tab[aria-pressed='true'] { background: var(--ew-green); border-color: var(--ew-green); color: #fff; }
`;

export function DirectoryStyles() {
  return <style>{css}</style>;
}
